import { InvokeServerMethodResponse } from 'marketplace/types/marketplace';
import { MarketplaceHttpClient } from './marketplace-http-client';

class ServerMethodHttpClient extends MarketplaceHttpClient {
  public invokeServerMethod = (
    appId: number,
    name: string,
    payload: unknown,
  ): Promise<InvokeServerMethodResponse> => {
    return this.post(`/apps/${appId}/server-actions/${name}/run`, payload);
  };
}

export const ServerMethodApi = new ServerMethodHttpClient();
